import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

// Cuánto queda en pantalla una frase del narrador. Siete segundos es el número del mockup: alcanza
// para leer una línea sin que el cartel se quede pegado tapando lo que viene abajo.
export const NARRATOR_HIDE_MS = 7000;

/**
 * El narrador: la voz de Dashbo mientras lee el material.
 *
 * Dice lo que está pasando en el momento en que pasa («Leyendo …», «Encontré 3 hechos»). Es lo
 * único que convierte una espera de treinta segundos en un proceso visible.
 *
 * Dos decisiones:
 *
 * 1. **La región `aria-live` está SIEMPRE montada**, aunque no haya frase. Un contenedor con
 *    `aria-live` que se monta junto con su texto no se anuncia: el lector de pantalla tiene que
 *    estar observando el nodo desde antes de que cambie.
 * 2. **La frase se identifica por `messageId`, no por su texto.** Dos documentos seguidos pueden
 *    producir la misma frase, y comparando strings el segundo no reiniciaría el reloj — el cartel
 *    se iría a los 7s del primero, en la mitad del segundo.
 */
export function BoosterNarrator({message, messageId = 0}) {
    const {t} = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!message) {
            setVisible(false);
            return undefined;
        }
        setVisible(true);
        const timer = setTimeout(() => setVisible(false), NARRATOR_HIDE_MS);
        // Sin esto, desmontar el acto (o encadenar dos ingestas) deja timers vivos que después
        // escriben sobre un componente que ya no está.
        return () => clearTimeout(timer);
    }, [message, messageId]);

    const showing = visible && !!message;

    return (
        <div className={`iab-narrator ${showing ? '-on' : ''}`}
             aria-live="polite" aria-atomic="true"
             aria-label={t('ia_booster.feed.narrator_aria')}>
            {showing && (
                <>
                    <span className="iab-narrator-bit" aria-hidden="true">D</span>
                    <span className="iab-narrator-txt">{message}</span>
                </>
            )}
        </div>
    );
}

export default BoosterNarrator;
